/**
 * "Informações da leitura" (E205.F4.T05, ADR-0147 §2.5): a ficha da leitura e a conferência, inteiras,
 * fora da mesa, pelo "Mais" do cabeçalho. É a mesma leitura de antes, para auditar o que a leitura
 * achou em cada documento e de onde veio; a correção de um campo é feita no documento, na mesa.
 *
 * O endereço `#ficha-da-leitura` (a tela de certificados, os links antigos da mesa) chega aqui.
 */
import { Link, useParams } from 'react-router-dom';

import { LeituraDoCaso } from '@/components/ConferenciaDaLeitura/LeituraDoCaso';
import { buttonVariants } from '@/components/ui';
import { ptBR } from '@/i18n/pt-BR';
import { useApiClient } from '@/lib/api';
import { cn } from '@/lib/utils';

const t = ptBR.documentosDoCaso.informacoes;

export function InformacoesDaLeituraPage(): JSX.Element {
  const { id: caseId = '' } = useParams<{ id: string }>();
  const client = useApiClient();
  return (
    <section
      className="space-y-sc-6 pb-sc-8"
      aria-labelledby="informacoes-da-leitura-titulo"
      data-testid="informacoes-da-leitura-page"
    >
      <header className="flex flex-wrap items-start justify-between gap-sc-4">
        <div className="min-w-0 space-y-1">
          <h1 id="informacoes-da-leitura-titulo" className="text-display-md text-fg">
            {t.titulo}
          </h1>
          <p className="max-w-prose text-body-md text-fg-muted">{t.texto}</p>
        </div>
        <Link
          to={`/casos/${caseId}/mesa#documentos`}
          className={cn(buttonVariants({ variant: 'secondary' }), 'no-underline')}
          data-testid="informacoes-da-leitura-voltar"
        >
          {t.voltar}
        </Link>
      </header>
      <LeituraDoCaso key={caseId} client={client} caseId={caseId} releitura={caseId} consulta />
    </section>
  );
}
